module.exports = __webpack_public_path__ + "static/media/diamond-shield.da2f0e7e.png";